module.exports = __webpack_public_path__ + "img/chart-square-bar.a81d9a79.svg";